<template>
  <v-container class="ma-0 pa-0 mw-100">
    <preview-modal
      :dialog="imgModal"
      :title="$t('Headers.preview')"
      :img="website_logo"
      @setCloseModal="imgModal = false"
    ></preview-modal>

    <validation-dialog
      :title="$t('InterfacePage.apply_changes_title')"
      :content="$t('InterfacePage.apply_changes_content')"
      :dialog="editInterfaceWeb"
      @close="editInterfaceWeb = false"
      @done="applyChangesWebsite"
      :buttons="[$t('Headers.cancel'), $t('Headers.save')]"
    />
    <validation-dialog
      :title="$t('InterfacePage.reset_changes_title')"
      :content="$t('InterfacePage.reset_changes_content')"
      :dialog="resetInterfaceWeb"
      @close="resetInterfaceWeb = false"
      @done="resetWeb"
      :buttons="[$t('Headers.cancel'), $t('Headers.save')]"
    />

    <v-form ref="form" @keyup.native.enter="editInterface = true">
      <v-row>
        <v-col cols="12" md="6" sm="6">
          <v-file-input
            filled
            :label="$t('InterfacePage.logo')"
            type="file"
            accept="image/*"
            @change="onFileChanged($event, 'website_full')"
          />
        </v-col>
        <v-col cols="12" md="6" sm="6">
          <v-expansion-panels accordion :value="0">
            <v-expansion-panel filled :value="0">
              <v-expansion-panel-header
                style="background: #ededed; color: grey"
                >{{ $t("InterfacePage.mainColor") }}</v-expansion-panel-header
              >
              <v-expansion-panel-content
                style="background: #ededed; color: grey"
              >
                <v-color-picker
                  style="background: #ededed; color: grey"
                  v-model="color_web"
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="12" class="text-right">
          <custom-button
            @click="imgModal = true"
            icon="mdi-eye"
            :text="$t('Headers.preview')"
          ></custom-button>
          <custom-button
            @click="resetInterfaceWeb = true"
            :text="$t('Headers.reset')"
          ></custom-button>
          <custom-button
            :disabled="!changed"
            @click="editInterfaceWeb = true"
            :text="$t('Headers.save')"
          ></custom-button>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import CustomButton from "../../components/ui/input/CustomButton";
import ValidationDialog from "../../components/ui/other/ValidationDialog";
import PreviewModal from "../../components/ui/other/PreviewModal";
import i18n from "../../i18n";
import { log } from "@/helpers/logger";

export default {
  name: "whitelabeling",
  title: i18n.t("InterfacePage.headline_overview"),
  components: {
    PreviewModal,
    CustomButton,
    ValidationDialog,
  },
  data() {
    return {
      changed: false,
      website_logo: null,
      style: null,
      file: null,
      color_web: null,
      editInterfaceWeb: false,
      resetInterfaceWeb: false,
      imgModal: false,
    };
  },
  created() {
    this.color_web = this.$vuetify.theme.themes.light.primary;
    this.style = this.$vuetify.theme.themes.light.primary;
    this.$store.commit("set_loading", false);
  },
  watch: {
    color_web() {
      this.style = this.color_web;
      this.changed = true;
    },
  },
  methods: {
    onFileChanged(e, name) {
      let reader = new FileReader();
      reader.onloadend = () => {
        let fileData = reader.result;
        if (name === "website_full") {
          this.website_logo = fileData;
        }
      };
      reader.readAsDataURL(e);
      this.changed = true;
    },
    alert(msg) {
      this.$store.commit("ui/set_notification", {
        display: true,
        code: msg,
        alertClass: "red",
      });
      return false;
    },
    applyChangesWebsite() {
      var data = {
        logo: this.website_logo,
        style: this.style,
        id: this.$store.state.auth.user.id,
      };
      this.$store
        .dispatch("data/putInterface", data)
        .catch((err) => {
          log("AdminPage.Whitelabeling.applyChangesWebsite() - " + err, "error");
        })
        .finally(() => {
          log(
            "AdminPage.Whitelabeling.applyChangesWebsite() - put interface " +
              data,
            "info"
          );
          this.$vuetify.theme.themes.light.primary =
            data.style;
          this.$vuetify.theme.themes.light.secondary =
            data.style;
          this.$vuetify.theme.themes.light.accent =
            data.style;

          window.location.reload();
        });
    },
    resetWeb() {
      let id = this.$store.state.auth.user.id;
      this.$store
        .dispatch("data/resetInterface", id)
        .catch((err) => {
          log("AdminPage.Whitelabeling.resetWeb() - " + err, "error");
        })
        .finally(() => {
          log(
            "AdminPage.Whitelabeling.resetWeb() - delete interface " + id,
            "info"
          );
          this.$store.commit("auth/set_user", user);
          this.$vuetify.theme.themes.light.primary =
            user.whitelabeling_pack.style;
          this.$vuetify.theme.themes.light.secondary =
            user.whitelabeling_pack.style;
          this.$vuetify.theme.themes.light.accent =
            user.whitelabeling_pack.style;

          window.location.reload();
        });
    },
  },
};
</script>
